import { Modal } from '../common/Modal';
import { IProjectPositionSearchResponse } from '../../interfaces/projectPostitionSearch';
import { StandardTextFieldProps, TextField } from '@mui/material';
import { ColumnBoxFlexFullWidth, FlexBoxFullWidth } from '../common/boxes';
import { PROJECT_POSITION_STATUS_MAP } from '../../enums/projectPositionStatus';
import { PAYMENT_RATE_MAP } from '../../enums/paymentRateType';
import { AVAILABILITY_TYPE_MAP } from '../../enums/AvailabilityType';
import { PROFICIENCY_MAP } from '../../interfaces/language';

interface IProps {
  onClose: () => void;
  position: IProjectPositionSearchResponse;
}

const InputDetails = (props: StandardTextFieldProps) => <TextField variant={'standard'} sx={{ mb: 1, ...props.sx }}
                                                                   disabled {...props}/>;

const PositionDetailsModal = ({ onClose, position }: IProps) => {

  return (
    <Modal onClose={onClose} maxWidth={800} withDividers={false}>
      <ColumnBoxFlexFullWidth>
        <FlexBoxFullWidth mb={1}>
          <InputDetails label={'ID'} value={position.id} sx={{width: '33%', mr: 1.5, flexGrow: 1}}/>
          <InputDetails label={'Project ID'} value={position.projectOpportunityId} sx={{width: '33%', mr: 1.5, flexGrow: 1}}/>
          <InputDetails label={'Client ID'} value={position.clientId} sx={{width: 80}}/>
        </FlexBoxFullWidth>
        <InputDetails label={'Role'} value={position.roleName}/>
        <InputDetails label={'Position Name'} value={position.positionName}/>
        <InputDetails label={'Client Name'} value={position.clientName}/>
        <InputDetails label={'Status'} value={PROJECT_POSITION_STATUS_MAP[position.status]}/>
        <InputDetails label={'Skills'} value={position.skills.join(', ')}/>
        <InputDetails label={'Position Title'} value={position.positionTitle}/>
        <InputDetails label={'Position Description'} value={position.positionDescription}/>
        <InputDetails label={'Link'} value={position.link}/>
        <InputDetails label={'Rate'} value={`${position.rate.amount} ${position.rate.currency} / ${PAYMENT_RATE_MAP[position.rate.type]}`}/>
        <InputDetails
          label={'Availability'}
          value={`from ${position.availabilityFromHour} to ${position.availabilityToHour} (${position.timezone}) - ${AVAILABILITY_TYPE_MAP[position.availabilityType]}`}
        />
        <InputDetails label={'Language'} value={`${position.language} - ${PROFICIENCY_MAP[position.languageProficiencyLevel]}`}/>
        <InputDetails label={'Project Title'} value={position.projectTitle}/>
        <InputDetails label={'Project Overview'} value={position.projectOverview}/>
        <InputDetails label={'Age In Days'} value={position.ageInDays}/>
        <InputDetails label={'Created'} value={position.auditDetails.createdOn}/>
        <InputDetails label={'Last Modified'} value={position.auditDetails.modifiedOn}/>
      </ColumnBoxFlexFullWidth>
    </Modal>
  );
};

export default PositionDetailsModal;